import { render, staticRenderFns } from "./yhgl.vue?vue&type=template&id=0c1c4fae&scoped=true&"
import script from "./yhgl.vue?vue&type=script&lang=js&"
export * from "./yhgl.vue?vue&type=script&lang=js&"
import style0 from "./yhgl.vue?vue&type=style&index=0&id=0c1c4fae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c4fae",
  null
  
)

export default component.exports